const styles = {
    container: {
        color: 'rgba(26,26,26,.9)',
        marginTop: 50
    },
    aboutHeaderMain: {
        color: 'rgb(61, 153, 145)'
    },
    aboutLink: {
        display: 'block',
        color: 'rgba(26,26,26,.9)',
        cursor: 'pointer',
        textDecoration: 'none',
        marginBottom: 10
    },
    aboutHeader: {
        marginTop: 0
    },
    teamDiv: {
        marginTop: 50
    }
};

export default styles;


// WEBPACK FOOTER //
// ./src/containers/About/AboutStyle.js